import "../rentaroomstyle.css";

export default function RentARoomDashboard() {
  return (
    <div className="rar-page">
      <div style={{ marginBottom: 24 }}>
        <h4 className="rar-page-title">
          <i className="bi bi-grid-fill me-2" style={{ color: "#3b82f6" }}></i>Dashboard
        </h4>
        <p className="rar-page-subtitle">RentARoom yönetim paneline hoş geldiniz.</p>
      </div>

      <div className="rar-stat-grid">
        {[
          { label: "Toplam Talep",    value: 0, icon: "bi-inbox-fill",        color: "#3b82f6", bg: "#eff6ff" },
          { label: "Aktif Sipariş",   value: 0, icon: "bi-bag-check-fill",    color: "#10b981", bg: "#f0fdf4" },
          { label: "Bekleyen",        value: 0, icon: "bi-hourglass-split",   color: "#f59e0b", bg: "#fffbeb" },
          { label: "Tamamlanan",      value: 0, icon: "bi-check-circle-fill", color: "#6b7280", bg: "#f9fafb" },
        ].map((s) => (
          <div key={s.label} className="rar-stat-card" style={{ background: s.bg }}>
            <div className="rar-stat-card-header">
              <span className="rar-stat-label" style={{ color: s.color }}>{s.label}</span>
              <i className={`bi ${s.icon}`} style={{ color: s.color, fontSize: "1rem" }}></i>
            </div>
            <span className="rar-stat-value">{s.value}</span>
          </div>
        ))}
      </div>

      <div className="rar-empty-card">
        <i className="bi bi-building" style={{ fontSize: "2.5rem", display: "block", marginBottom: 12 }}></i>
        <p style={{ margin: 0, fontSize: "0.9rem" }}>İçerik yakında eklenecek.</p>
      </div>
    </div>
  );
}
